<script>
import { beforeUpdate, onMount } from "svelte";


    export let direction = 'up';
    $: dir = direction;
    export let color = 'gray';
    export let cls = '';

    beforeUpdate(()=> {
        if(dir == 1) dir = "up"
        if(dir == -1) dir = "down"
        if(dir == 0) dir = "hide"
        if(dir == 2) dir = "right"
        
    })
</script>

<svg class="arrow-icon {dir} {color} {cls}"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24 22h-24l12-20z"/></svg>


<style lang="scss">
    .arrow-icon {
        height: 10px;
    }
    .px {
        padding: 0 .2rem;
    }
    .red {
        fill: color('red');
    }
    .green {
        fill: color('green');
    }
    .gray {
        fill: color('dark');
    }
    .down {
        transform: rotate(180deg);
    }
    .right {
        transform: rotate(90deg);

    }

    .hide {
        display: none;
    }

    .small {
      height: 8px;
      width: 8px;
  }
</style>